export default __webpack_public_path__ + "static/media/Hedda_glad.f1a4b0ea.jpg";